import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleQhse = {
  namespaced: true,

  state: {
    name: 'qhse',
    nextSeqCode: null,
    
    qhses: []
  },

  mutations,
  getters,
  actions
}

export default moduleQhse;